/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useMemo, useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';
import { useMutation, ErrorTypes } from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiAddOrganizationMemberRequest,
  getCoinbaseEngUsersAccountManagementApiApiAddOrganizationMemberRequestErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiAddOrganizationMemberRequest';
import {
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponse,
  getCoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponse';

type AddOrganizationMemberMutationArgs =
  CoinbaseEngUsersAccountManagementApiApiAddOrganizationMemberRequest;

export type AddOrganizationMemberResult =
  CoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponse;

const validateAddOrganizationMemberResult = (value: unknown) => {
  const errors =
    getCoinbaseEngUsersAccountManagementApiApiUpdateOrganizationMembersResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: AddOrganizationMemberResult data does not match contract.`,
      errors,
    );
  }
};

type HookReturnType = (
  payload: Readonly<AddOrganizationMemberMutationArgs>,
  options?: RequestInit,
) => Promise<AddOrganizationMemberResult | ErrorTypes>;

export const getAddOrganizationMemberUrl = () => {
  const searchParams = new URLSearchParams();
  const url = `${getBaseUrl()}/organization/v1/members${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Put AddOrganizationMember
 * @Url /organization/v1/members
 * @Auth Required
 */
export const useAddOrganizationMember = (): HookReturnType => {
  const mutation = useMutation<unknown, AddOrganizationMemberResult>();

  const callback = useCallback(
    async (payload: Readonly<AddOrganizationMemberMutationArgs>, options?: RequestInit) => {
      const postBody = {
        legal_entity_ids: payload.legalEntityIds,
        member: payload.member,
        legal_entity_roles: payload.legalEntityRoles,
      };

      const init = { ...(options || {}), method: 'PUT' };

      const url = getAddOrganizationMemberUrl();
      const result = await mutation(url, postBody, init);
      if (process.env.NODE_ENV !== 'production') {
        validateAddOrganizationMemberResult(result);
      }
      return result;
    },
    [mutation],
  );

  return callback;
};
